import { Controller } from '@hotwired/stimulus';
import { toggleVisiblity } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'teamRadioButton',
    'utmCampaignSection',
    'utmCampaignInput',
    'followWallRadioButton',
    'followWallInput',
  ];
  static values = {
    activeTeam: { type: String, default: 'authors' },
  };

  connect() {
    const activeTeamFromStorage = localStorage.getItem(
      this.activeTeamLocalStorageKey
    );
    if (activeTeamFromStorage) {
      this.activeTeamValue = activeTeamFromStorage;
    }
  }

  changeTeam(event) {
    this.activeTeamValue = event.params.teamValue;
    localStorage.setItem(this.activeTeamLocalStorageKey, this.activeTeamValue);
  }

  activeTeamValueChanged() {
    this.teamRadioButtonTargets.forEach((target) => {
      target.checked = target.value === this.activeTeamValue;
    });

    const hideAndDisableUtmCampaign = this.activeTeamValue !== 'marketing';
    toggleVisiblity(this.utmCampaignSectionTarget, !hideAndDisableUtmCampaign);
    this.utmCampaignInputTarget.disabled = hideAndDisableUtmCampaign;
  }

  lifetimeChanged() {
    this.followWallInputTarget.value = this.followWallRadioButtonTarget.checked;
  }

  get activeTeamLocalStorageKey() {
    return 'author-share-urls:active-team';
  }
}
